import app from "../_app";

document.addEventListener("DOMContentLoaded", function (event) {

    let clearBtn = document.querySelector("#clear-discount-btn");
    let applyBtn = document.querySelector("#apply-discount-btn");
    let discountCodeError = document.querySelector("#discount-code-error");
    let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
    let discountCodeInput = document.querySelector("#discount-code-input");
    let totalCartSelector = document.querySelector(".cart__summary-totalprice"); // Total Cart Selector to update the total amount.

    let checkoutContainer = document.createElement('div');
    document.body.appendChild(checkoutContainer);
    if (localStorage.discountCode) applyDiscount(JSON.parse(localStorage.discountCode).code);
    if (applyBtn)
        applyBtn.addEventListener("click", function (e) {
            e.preventDefault()
            applyDiscount(discountCodeInput.value);
        });
    if (clearBtn)
        clearBtn.addEventListener("click", function (e) {
            e.preventDefault()
            clearDiscount();
        });

    function clearDiscount() {
        discountCodeValue.innerHTML = "";
        discountCodeError.innerHTML = "";
        clearLocalStorage();
        fetch("/discount/CLEAR");
    }

    function clearLocalStorage() {
        if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
        if (totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
        localStorage.removeItem("discountCode");
    }

    function applyDiscount(code) {
        if (applyBtn) {
            applyBtn.innerHTML = app.translationHelper('cart.discount.applying') + "<div class='loader'></div>";
            applyBtn.style.pointerEvents = "none";
        }
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ discount: code })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
});
